import { useToasts, Modal, ModalHeader, ModalTitle, ModalCloseIcon, ModalContent, ModalSection, Text, Label, ModalFooter, Button } from '@bloobirds-it/flamingo-ui';
import { useState, useEffect } from 'react';
import { ACTIVITY_FIELDS_LOGIC_ROLE, REPORTED_VALUES_LOGIC_ROLE, BobjectTypes } from '@bloobirds-it/types';
import { api, getFieldByLogicRole, getReferencedBobject, getTextFromLogicRole, getNameFieldLRFromBobjectType } from '@bloobirds-it/utils';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".meetingReportresult-module__section__wrapper__m0i-- {\n  margin-bottom: 24px;\n}\n\n.meetingReportresult-module__section_title__wrapper__xMV7Y {\n  margin-bottom: 16px;\n}\n\n.meetingReportresult-module__labels__wrapper__wiSC9 {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: space-around;\n}\n\n.meetingReportresult-module__label__content__y220A {\n  display: flex;\n  flex-direction: column;\n  width: 225px;\n  margin-bottom: 12px;\n}\n\n.meetingReportresult-module__label__content__y220A > div {\n  margin-bottom: 12px;\n}\n\n.meetingReportresult-module__buttons__wrapper__ZLz35 {\n  display: flex;\n  width: 100%;\n}\n\n.meetingReportresult-module__buttons__wrapper__ZLz35 > button:nth-child(2) {\n  margin-left: auto;\n  margin-right: 16px;\n}\n";
var styles = {"_section__wrapper":"meetingReportresult-module__section__wrapper__m0i--","_section_title__wrapper":"meetingReportresult-module__section_title__wrapper__xMV7Y","_labels__wrapper":"meetingReportresult-module__labels__wrapper__wiSC9","_label__content":"meetingReportresult-module__label__content__y220A","_buttons__wrapper":"meetingReportresult-module__buttons__wrapper__ZLz35"};
styleInject(css_248z);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useMeetingReportResult = function useMeetingReportResult(dataModel) {
  var _dataModel$getFieldsB, _dataModel$getFieldsB2, _dataModel$getFieldsB3, _dataModel$getFieldsB4;
  var meetingResults = dataModel === null || dataModel === void 0 ? void 0 : (_dataModel$getFieldsB = dataModel.getFieldsByBobjectType('Activity')) === null || _dataModel$getFieldsB === void 0 ? void 0 : (_dataModel$getFieldsB2 = _dataModel$getFieldsB.find(function (datamodelField) {
    return datamodelField.logicRole === ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_RESULT;
  })) === null || _dataModel$getFieldsB2 === void 0 ? void 0 : (_dataModel$getFieldsB3 = _dataModel$getFieldsB2.values) === null || _dataModel$getFieldsB3 === void 0 ? void 0 : (_dataModel$getFieldsB4 = _dataModel$getFieldsB3.filter(function (value) {
    return value === null || value === void 0 ? void 0 : value.isEnabled;
  })) === null || _dataModel$getFieldsB4 === void 0 ? void 0 : _dataModel$getFieldsB4.sort(function (a, b) {
    return a.ordering - b.ordering;
  });
  var reportResult = function reportResult(activity, meetingResult) {
    var _activityData;
    var accountId = activity.id.accountId;
    var activityId = activity.id.objectId;
    var activityData = (_activityData = {}, _defineProperty(_activityData, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_RESULT, meetingResult === null || meetingResult === void 0 ? void 0 : meetingResult.id), _defineProperty(_activityData, ACTIVITY_FIELDS_LOGIC_ROLE.REPORTED, meetingResult ? REPORTED_VALUES_LOGIC_ROLE.YES : REPORTED_VALUES_LOGIC_ROLE.NO), _activityData);
    return api.patch("/bobjects/".concat(accountId, "/Activity/").concat(activityId, "/raw"), activityData);
  };
  return {
    reportResult: reportResult,
    meetingResults: meetingResults
  };
};

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MeetingReportResultModal = function MeetingReportResultModal(_ref) {
  var _referencedBobject$id;
  var handleClose = _ref.handleClose,
    activity = _ref.activity,
    dataModel = _ref.dataModel;
  var defaultMeetingResult = getFieldByLogicRole(activity, ACTIVITY_FIELDS_LOGIC_ROLE.MEETING_RESULT);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMeetingResult = _useState2[0],
    setSelectedMeetingResult = _useState2[1];
  var _useMeetingReportResu = useMeetingReportResult(dataModel),
    reportResult = _useMeetingReportResu.reportResult,
    meetingResults = _useMeetingReportResu.meetingResults;
  var _useToasts = useToasts(),
    createToast = _useToasts.createToast;
  var referencedBobject = getReferencedBobject(activity);
  var referencedBobjectName = getTextFromLogicRole(referencedBobject, getNameFieldLRFromBobjectType(referencedBobject === null || referencedBobject === void 0 ? void 0 : (_referencedBobject$id = referencedBobject.id) === null || _referencedBobject$id === void 0 ? void 0 : _referencedBobject$id.typeName));
  function handleSubmit(e) {
    reportResult(activity, selectedMeetingResult).then(function () {
      createToast({
        message: 'Meeting reported',
        type: 'success'
      });
      handleClose(e);
      window.dispatchEvent(new CustomEvent('ACTIVE_BOBJECT_UPDATED', {
        detail: {
          type: BobjectTypes.Activity
        }
      }));
    });
  }
  useEffect(function () {
    if (!selectedMeetingResult) {
      setSelectedMeetingResult({
        id: defaultMeetingResult === null || defaultMeetingResult === void 0 ? void 0 : defaultMeetingResult.value,
        logicRole: defaultMeetingResult === null || defaultMeetingResult === void 0 ? void 0 : defaultMeetingResult.valueLogicRole
      });
    }
  }, []);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs(Modal, {
      width: 680,
      open: true,
      onClose: handleClose,
      children: [/*#__PURE__*/jsxs(ModalHeader, {
        children: [/*#__PURE__*/jsx(ModalTitle, {
          color: "peanut",
          icon: "company",
          size: "small",
          children: "Report Meeting Result"
        }), /*#__PURE__*/jsx(ModalCloseIcon, {
          color: "peanut",
          size: "small",
          onClick: handleClose
        })]
      }), /*#__PURE__*/jsx(ModalContent, {
        children: /*#__PURE__*/jsxs(ModalSection, {
          size: "l",
          title: "You just finished a meeting with ".concat(referencedBobjectName),
          icon: "calendar",
          children: [/*#__PURE__*/jsx("div", {
            className: styles._section__wrapper,
            children: /*#__PURE__*/jsx("div", {
              className: styles._section_title__wrapper,
              children: /*#__PURE__*/jsx(Text, {
                size: "m",
                weight: "medium",
                color: "peanut",
                children: "What is the meeting result?*"
              })
            })
          }), /*#__PURE__*/jsx("div", {
            className: styles._labels__wrapper,
            children: /*#__PURE__*/jsx("div", {
              className: styles._label__content,
              children: meetingResults && (meetingResults === null || meetingResults === void 0 ? void 0 : meetingResults.map(function (result) {
                return /*#__PURE__*/jsx(Label, {
                  uppercase: false,
                  inline: false,
                  align: "center",
                  selected: selectedMeetingResult && [result === null || result === void 0 ? void 0 : result.logicRole, result.id].includes(selectedMeetingResult.id),
                  onClick: function onClick() {
                    return setSelectedMeetingResult(result);
                  },
                  children: result === null || result === void 0 ? void 0 : result.name
                }, "meeting-result-".concat(result === null || result === void 0 ? void 0 : result.id));
              }))
            })
          })]
        })
      }), /*#__PURE__*/jsx(ModalFooter, {
        children: /*#__PURE__*/jsxs("div", {
          className: styles._buttons__wrapper,
          children: [/*#__PURE__*/jsx(Button, {
            variant: "clear",
            onClick: handleClose,
            children: "Cancel"
          }), /*#__PURE__*/jsx(Button, {
            dataTest: "Form-Save",
            onClick: handleSubmit,
            children: "SAVE AND CONTINUE"
          })]
        })
      })]
    })
  });
};

export { MeetingReportResultModal };
